module.exports = __webpack_public_path__ + "static/media/change-password-active-vector.c23165b9.svg";